import React, {useState} from 'react'
import { Button, Modal } from 'react-bootstrap';
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import {updatePath} from '../../store/auth/auth'

export default function ForgotPasswordModel({showForgotPassword, setShowForgotPassword}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

    const handleClose = () => setShowForgotPassword(false);
    const handleShow = () => {
      dispatch(updatePath('resetPassword'))
      navigate("/resetPassword")
    };

    

 

  return (


      <Modal show={showForgotPassword} size="sm" 
      aria-labelledby="contained-modal-title-vcenter" onHide={handleClose} centered >
        
        <Modal.Body className='bg-dark text-white rounded text-center'>
            <div className='mt-3'>
               <p>Tips</p> 
            </div>
            <div className='mt-5 mb-5'>
                <span>
                For security purposes, no withdrawals are permitted for 24 hours after modification of security methods.
                </span>
            </div>
            <div className='d-flex justify-content-center gap-5 mt-4 mb-3'>
                <Button variant='secondary w-100' onClick={handleClose}>Cancel</Button>
                <Button variant='warning w-100' onClick={handleShow}>Confirm</Button>
            </div>
        </Modal.Body>
       
      </Modal>
  )
}
